/**
 * PopupOpener — 사용자PC(/u/orders) 오더 상세팝업(거래명세서/계산서 편집창)의 진입점(중앙 허브).
 *
 * 레거시와의 관계
 * ───────────────
 * 기존 public/js/u-order-list.js 의 팝업 오프너 전역함수를 이관했다(세금/다중발행 코어 슬라이스 E).
 *   - allSetIn_new     : 목록에서 오더 클릭 시 초기화 후 show_Pop_BizForm 호출
 *   - show_Pop_BizForm : 상세팝업 오픈(초기화 → GET /u/ajax/order-tax/bizform → DOM 구성)
 *   - renderPayMemoHtml: 결제/오더 메모 JSON → 레거시 HTML 테이블 렌더
 *   - readMgonly_new   : 메모 목록 조회(show_Pop_BizForm 전용 내부 함수)
 *
 * 구조: 모듈 스코프 자유함수 + 얇은 브리지 클래스.
 *   - readMgonly_new 은 show_Pop_BizForm 만 호출 → 브리지하지 않고 모듈 스코프로만 둔다.
 *   - renderPayMemoHtml 은 **반드시** window 브리지 — MemoMessage 모듈(G)이 bare 로 호출한다.
 *   - 이미 이관된 콜리들은 전부 window 브리지라 bare 로 해소:
 *       hide_filterList(FilterDropdown) · make_checkBoxStatus(CheckboxHelpers) · addListeners(DragMove) ·
 *       showDetailList_inside(ExpensePanel) · check_BillStatus_new(BillStatus) · messagedeleteone(MemoMessage, onclick 문자열)
 *   - 전역 유틸/객체 bare: orderTax(window) · swalert · getCookie · mobiscroll · $
 *   - 공유 상태 쓰기는 window.* 로:
 *       popCallmode(선언없는 암시적 전역) · apply_after_reselect(암시적) · last_multiselRadio(암시적) ·
 *       onList(암시적) · multiMoreList(list.js var) · lastPageCheckSt(list.js var).
 *     (모두 잔류 list.js 코드가 bare 로 읽으므로 같은 window 프로퍼티를 공유)
 *
 * 서버: GET /u/ajax/order-tax/bizform · POST /u/ajax/orders/pay-memo
 */
import Store from '../../../Common/Store';
import Util from '../../../Common/Util';


function allSetIn_new(ordernum,callmode){
    document.getElementById("ismultiGolist").checked = false;
    window.lastPageCheckSt = {};
    show_Pop_BizForm(ordernum,callmode);
}

/**
 * 사용자 PC 접수목록에서 특정 오더클릭시 팝업화면을 띄운다.
 * @param ordernum
 * @param callmode
 */
function show_Pop_BizForm(ordernum, callmode) {
    // 초기화 작업
    hide_filterList();
    orderTax.current_ordernum = ordernum;
    window.popCallmode = callmode;
    window.apply_after_reselect = 0;
    window.multiMoreList = [];
    window.last_multiselRadio = 0;

    // DOM 조작
    $("#popWinOrderNum").text(ordernum);
    $("#show_paymtStatus, #crd").hide();
    $("#orderEdit").hide();
    $("#editorderFrame").attr("src", "");
    $("#handleordernumnum").val(ordernum);
    $("#ordernums").val(ordernum);

    $(".checkBodTd").css("background-color", "#FFFFFF");
    make_checkBoxStatus();

    // AJAX 호출
    const adr = "/u/ajax/order-tax/bizform";
    const sendData = {
        "orderNum": ordernum,
        "callmode": callmode
    };

    $.get(adr, sendData, function (data) {
        if (data.includes("NOTRELATED_JbAutoDelte")) {
            Util.swalert("해당 오더 수주자 또는 발주자가 변경되었습니다.\n더 이상 연관 없는 오더입니다.");
            return;
        }

        // 데이터 처리 및 스타일 수정
        const ww = $(window).width();
        const wHs = $(window).height();
        let hhf = Math.max(800, Math.min(ww * 0.8, 750));
        let gabs = Math.max(10, (ww - hhf) / 2);

        let posDefX = parseInt(Store.cookie.get("posDefX"), 10) || gabs;
        let posDefY = parseInt(Store.cookie.get("posDefY"), 10) || 50;

        posDefY = Math.max(10, Math.min(posDefY, wHs));

        $("#detailLists").css({
            display: "block",
            position: "fixed",
            left: `${posDefX}px`,
            top: `${posDefY}px`,
            width: `${hhf}px`
        });

        if (wHs < 900) {
            $("#orderEdit").css("height", `${wHs}px`);
            $("#editorderFrame").css({
                height: `${wHs - 100}px`,
                maxHeight: `${wHs - 100}px`
            });
        } else {
            $("#orderEdit").css("height", "900px");
            $("#editorderFrame").css({
                height: "800px",
                maxHeight: "800px"
            });
        }

        $("#detailInside").html(data);
        addListeners("editTopTitle", "detailLists");
        window.onList = [ordernum];

        // 업데이트 및 기타 호출
        readMgonly_new(ordernum);
        showDetailList_inside(ordernum);

        const checkBodTds = $(`#checkBodTds_${ordernum}`);
        const thisorder_payType = parseInt($("#thisorder_payType").val(), 10);
        const thisorder_soobalType = parseInt($("#thisorder_soobalType").val(), 10);

        $("#baltype1, #baltype2, #baltype5").prop("disabled", false).prop("checked", false);

        if (thisorder_payType === 1) $("#baltype1").prop("checked", true);
        if (thisorder_payType === 2) $("#baltype2").prop("checked", true);
        if ([9, 3, 5].includes(thisorder_payType)) $("#baltype5").prop("checked", true);

        checkBodTds.css("background-color", "#086bff");
        check_BillStatus_new();

        // Mobiscroll 설정
        $("#billdate, #paystae_date, #bal_gave_when, #bal_gotbill_when").mobiscroll().datepicker({
            controls: ["calendar"],
            dateFormat: "YYYY-MM-DD",
            locale: mobiscroll.localeKo,
            buttons: []
        });
    });
}

/**
 * 결제/오더 메모 JSON(memos[])을 레거시 HTML 테이블로 렌더 (saveorderpaymemo 이관)
 */
function renderPayMemoHtml(data){
    var memos = (data && data.memos) ? data.memos : [];
    var ret = "<table style='border-collapse:collapse; white-space:nowrap;width:100%;table-layout:fixed; margin:0px auto' border=1 borderColor='#C0C0C0'>"
            + "<colgroup><col style='width:*'/><col style='width:120px'/><col style='width:50px'/></colgroup>";
    for( var i=0; i<memos.length; i++ ){
        var r = memos[i];
        var TT = "<i class=\"fa-solid fa-bullhorn\" style=\"margin-right:4px\"></i>";
        if( r.rel_table == 'MY' ){
            var icon = (parseInt(r.rel_desc)==1) ? "memotype_icon_pc" : "memotype_icon_app";
            TT = "<img src='/img/"+icon+".png' style='height:14px; position:relative;top:2px'>";
        }
        var dt = (r.datetime || "").substr(2,14);
        var writer = r.writer_name ? (Util.escapeHtml(r.writer_name) + " ") : "";
        ret += "<tr style='height:23px'>"
             + "<td style='white-space:normal; word-break:break-all; text-align:left; padding-left:12px'>" + TT + Util.escapeHtml(r.memo).replace(/&lt;\/?br\s*\/?&gt;/gi, '<br>') + "</td>"
             + "<td style='padding-right:3px'>" + writer + dt + "</td>";
        if( r.rel_table == 'MY' ){
            ret += "<td><a href='javascript:messagedeleteone(" + r.num + "," + r.rel_id + ")'>삭제</a></td>";
        }
        ret += "</tr>";
    }
    ret += "</table><div style='display:none' id='mgLastshowagain'>" + Util.escapeHtml((data && data.last_showmg) ? data.last_showmg : "") + "</div>";
    return ret;
}

/**
 * 결제 메모 목록 가져오기
 * @param n
 */
function readMgonly_new(n){
    var obj2 = document.getElementById("messageListloadon");
    var adr = "/u/ajax/orders/pay-memo";
    var sendData = {"eOrderNum":n,"message":""};
    $.ajax({type:"POST", url:adr, data:sendData, success:function(data){
            obj2.innerHTML = renderPayMemoHtml(data);
        }});
}

export default class PopupOpener {
    allSetIn_new = allSetIn_new;
    show_Pop_BizForm = show_Pop_BizForm;
    renderPayMemoHtml = renderPayMemoHtml;
}
